import React, { useEffect } from 'react';
import { ArrowLeft, Shield, Lock, Eye, Mail, Server, UserCheck, AlertCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const goHome = () => {
    window.dispatchEvent(new CustomEvent('nova-navigate', {
      detail: 'home'
    }));
  };
  const sections = [{
    icon: <Eye className="text-nova-accent" size={24} data-id="element-309" />,
    title: '1. Información que Recopilamos',
    content: <>
          <p className="mb-3" data-id="element-310">
            En NovaWeb recopilamos información personal cuando contratas
            nuestros servicios de diseño web. Los datos que podemos solicitar
            incluyen:
          </p>
          <ul className="space-y-2 list-disc list-inside text-nova-text-muted" data-id="element-311">
            <li data-id="element-312">Nombre completo o razón social del negocio</li>
            <li data-id="element-313">Número de WhatsApp y/o teléfono de contacto</li>
            <li data-id="element-314">Correo electrónico</li>
            <li data-id="element-315">
              Información del negocio (servicios, productos, ubicación,
              horarios)
            </li>
            <li data-id="element-316">
              Logotipos, imágenes y contenido proporcionado por el cliente
            </li>
            <li data-id="element-317">
              Datos necesarios para el registro de dominio (NIC.co u otros
              registradores)
            </li>
            <li data-id="element-318">
              Información de pago (procesada por pasarelas externas seguras)
            </li>
          </ul>
        </>
  }, {
    icon: <UserCheck className="text-nova-accent" size={24} data-id="element-319" />,
    title: '2. Cómo Usamos Tu Información',
    content: <>
          <p className="mb-3" data-id="element-320">
            Usamos tu información únicamente para los fines relacionados con la
            prestación de nuestros servicios:
          </p>
          <ul className="space-y-2 list-disc list-inside text-nova-text-muted" data-id="element-321">
            <li data-id="element-322">
              Diseñar, desarrollar y publicar tu página web o landing page
            </li>
            <li data-id="element-323">
              Registrar el dominio y configurar el hosting incluido en tu plan
            </li>
            <li data-id="element-324">Crear los correos corporativos contratados</li>
            <li data-id="element-325">
              Comunicarnos contigo durante el proceso (principalmente por
              WhatsApp)
            </li>
            <li data-id="element-326">Brindar el soporte inicial incluido en tu plan</li>
            <li data-id="element-327">
              Emitir facturas y cumplir con obligaciones legales y tributarias
              en Colombia
            </li>
          </ul>
        </>
  }, {
    icon: <Server className="text-nova-accent" size={24} data-id="element-328" />,
    title: '3. Compartición con Terceros',
    content: <>
          <p className="mb-3" data-id="element-329">
            No vendemos ni alquilamos tus datos personales. Compartimos
            información estrictamente necesaria con:
          </p>
          <ul className="space-y-2 list-disc list-inside text-nova-text-muted" data-id="element-330">
            <li data-id="element-331">
              <strong className="text-nova-text" data-id="element-332">
                Proveedores de hosting y dominio:
              </strong>{' '}
              para registrar tu dominio y alojar tu sitio web durante el año
              incluido en tu plan.
            </li>
            <li data-id="element-333">
              <strong className="text-nova-text" data-id="element-334">Pasarelas de pago:</strong>{' '}
              procesan transacciones de forma segura sin que NovaWeb almacene
              datos financieros sensibles.
            </li>
            <li data-id="element-335">
              <strong className="text-nova-text" data-id="element-336">Autoridades:</strong>{' '}
              únicamente cuando sea requerido por ley colombiana.
            </li>
          </ul>
        </>
  }, {
    icon: <Lock className="text-nova-accent" size={24} data-id="element-337" />,
    title: '4. Seguridad de los Datos',
    content: <p data-id="element-338">
          Implementamos medidas técnicas y organizativas razonables para
          proteger tu información: conexiones cifradas (HTTPS/SSL en todos los
          sitios entregados), accesos restringidos y respaldos. Sin embargo,
          ningún sistema en internet es 100% infalible y nos comprometemos a
          notificar cualquier incidente relevante.
        </p>
  }, {
    icon: <Shield className="text-nova-accent" size={24} data-id="element-339" />,
    title: '5. Tus Derechos (Ley 1581 de 2012 — Colombia)',
    content: <>
          <p className="mb-3" data-id="element-340">Como titular de los datos, tienes derecho a:</p>
          <ul className="space-y-2 list-disc list-inside text-nova-text-muted" data-id="element-341">
            <li data-id="element-342">Conocer, actualizar y rectificar tus datos personales</li>
            <li data-id="element-343">Solicitar prueba de la autorización otorgada</li>
            <li data-id="element-344">Ser informado sobre el uso que se ha dado a tus datos</li>
            <li data-id="element-345">Revocar la autorización y/o solicitar la supresión del dato</li>
            <li data-id="element-346">
              Presentar quejas ante la Superintendencia de Industria y Comercio
              (SIC)
            </li>
          </ul>
          <p className="mt-3" data-id="element-347">
            Para ejercer estos derechos escríbenos por WhatsApp al{' '}
            <a href="https://wa.me/573508108717" className="text-nova-accent hover:underline" data-id="element-348">
              3508108717
            </a>
            .
          </p>
        </>
  }, {
    icon: <AlertCircle className="text-nova-accent" size={24} data-id="element-349" />,
    title: '6. Cookies y Tecnologías Similares',
    content: <p data-id="element-350">
          Los sitios web que diseñamos pueden incluir cookies básicas para
          análisis (Google Analytics) o funcionalidad (formularios, mapas). El
          uso específico de cookies en cada sitio entregado se rige por la
          política del propio cliente final una vez el sitio le sea entregado.
        </p>
  }, {
    icon: <Mail className="text-nova-accent" size={24} data-id="element-351" />,
    title: '7. Conservación de los Datos',
    content: <p data-id="element-352">
          Conservamos tu información durante el tiempo que dure la relación
          contractual y por los plazos legales aplicables (mínimo 10 años para
          soportes contables y tributarios según normativa colombiana). Una vez
          vencidos los plazos, los datos serán eliminados de forma segura.
        </p>
  }, {
    icon: <Mail className="text-nova-accent" size={24} data-id="element-353" />,
    title: '8. Contacto',
    content: <>
          <p className="mb-3" data-id="element-354">
            Para cualquier consulta relacionada con esta Política de Privacidad
            o el tratamiento de tus datos personales:
          </p>
          <ul className="space-y-2 text-nova-text-muted" data-id="element-355">
            <li data-id="element-356">
              <strong className="text-nova-text" data-id="element-357">
                NovaWeb — Agencia de Diseño Web
              </strong>
            </li>
            <li data-id="element-358">
              WhatsApp:{' '}
              <a href="https://wa.me/573508108717" className="text-nova-accent hover:underline" data-id="element-359">
                3508108717
              </a>
            </li>
          </ul>
        </>
  }];
  return <div className="min-h-screen bg-nova-bg text-nova-text font-poppins pt-32 pb-24" data-id="element-360">
      <div className="max-w-4xl mx-auto px-6" data-id="element-361">
        <button onClick={goHome} className="inline-flex items-center gap-2 text-nova-text-muted hover:text-nova-accent transition-colors mb-8 text-sm font-medium" data-id="element-362">
          <ArrowLeft size={18} data-id="element-363" />
          Volver al inicio
        </button>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-364">
          <div className="flex items-center gap-3 mb-4" data-id="element-365">
            <Shield className="text-nova-accent" size={36} data-id="element-366" />
            <h1 className="text-3xl md:text-4xl font-bold" data-id="element-367">
              Política de Privacidad
            </h1>
          </div>
          <p className="text-nova-text-muted mb-12" data-id="element-368">
            Última actualización: enero de 2026 · NovaWeb — Agencia de Diseño
            Web
          </p>

          <div className="bg-nova-card border border-nova-bg-alt rounded-2xl p-6 md:p-8 mb-12" data-id="element-369">
            <p className="text-nova-text-muted leading-relaxed" data-id="element-370">
              En <strong className="text-nova-text" data-id="element-371">NovaWeb</strong> respetamos
              tu privacidad y nos comprometemos a proteger los datos personales
              que nos compartes cuando contratas nuestros servicios de diseño
              web profesional, landing pages, sitios web para negocios y planes
              Plus. Esta política explica qué información recopilamos, cómo la
              usamos y cuáles son tus derechos según la legislación colombiana
              de protección de datos (Ley 1581 de 2012 y sus decretos
              reglamentarios).
            </p>
          </div>

          <div className="space-y-8" data-id="element-372">
            {sections.map((section, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className="bg-nova-card border border-nova-bg-alt rounded-2xl p-6 md:p-8" data-id="element-373">
                <div className="flex items-center gap-3 mb-4" data-id="element-374">
                  {section.icon}
                  <h2 className="text-xl md:text-2xl font-semibold" data-id="element-375">
                    {section.title}
                  </h2>
                </div>
                <div className="text-nova-text-muted leading-relaxed" data-id="element-376">
                  {section.content}
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </div>;
}